import { BaseService } from '@/core/base-service';

export default class QuestionnaireService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/questionnaire');
  }
}
